/**
 * rc-legacy-add-guard.js (RC-owned; D-067, QA DEF-001)
 * ---------------------------------------------------------------------------
 * Production's legacy buy box (assets/rc-legacy.js, production's theme.js
 * verbatim) never checks for an add already in flight: a double-click, or the
 * main button then the sticky one, sends two /cart/add requests and adds two.
 * Its `loading` class only restyles the button.
 *
 * This guard watches jQuery's global ajax events for requests to /cart/add
 * (the buy box's adds, from the main and sticky buttons and the bundle form,
 * go through jQuery; the pair card and the drawer have their own paths and are
 * not guarded) and, while one is pending, or for a short cooldown after a
 * success (the legacy code redirects or opens the drawer right after), ignores
 * further trusted clicks on those buttons. A failed add unlocks at once, so
 * the shopper can retry. "Pending" is read from each request's readyState,
 * which jQuery sets before running callbacks, so a callback that throws (and
 * so skips ajaxComplete) cannot leave the buttons locked.
 *
 * Loaded on legacy-zone pages only, deferred, after jQuery (layout/theme.liquid).
 * Never throws: any error lets the click through.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var $ = window.jQuery;
  if (!$ || window.__rcLegacyAddGuard) return;
  window.__rcLegacyAddGuard = true;

  var LOCK_MAX_MS = 15000; // a request that never completes stops blocking (as D-048's ADD_LOCK_MAX_MS)
  var SUCCESS_COOLDOWN_MS = 800;
  var ADD_BUTTONS = '[data-add-to-cart], bundle-form button';

  var requests = []; // cart adds sent: { xhr: jqXHR, since: ms }
  var lockedUntil = 0;

  function isCartAdd(settings) {
    return !!(settings && typeof settings.url === 'string' && settings.url.indexOf('/cart/add') !== -1);
  }

  $(document).on('ajaxSend', function (event, xhr, settings) {
    if (!isCartAdd(settings)) return;
    requests.push({ xhr: xhr, since: Date.now() });
  });

  $(document).on('ajaxComplete', function (event, xhr, settings) {
    if (!isCartAdd(settings)) return;
    if (xhr && xhr.status >= 200 && xhr.status < 300) lockedUntil = Date.now() + SUCCESS_COOLDOWN_MS;
  });

  function addInFlight() {
    var now = Date.now();
    // jQuery 2.2.3: readyState 1 while sending, 4 (or 0 when aborted or failed) once done, set before callbacks.
    requests = requests.filter(function (request) {
      return request.xhr && request.xhr.readyState === 1 && now - request.since < LOCK_MAX_MS;
    });
    return requests.length > 0 || now < lockedUntil;
  }

  // Capture phase on window: runs before the handlers theme.js binds on the buttons. Enter and Space on a button,
  // and Enter in a field (implicit submission), reach the buttons as clicks too.
  window.addEventListener(
    'click',
    function (event) {
      try {
        if (!event.isTrusted) return;
        var target = event.target instanceof Element ? event.target : null;
        var button = target && target.closest(ADD_BUTTONS);
        if (!button || !button.closest('main.rc-legacy-zone')) return;
        if (!addInFlight()) return;

        // Both: the buttons are type="submit", so stopping propagation alone would let a native POST through.
        event.preventDefault();
        event.stopImmediatePropagation();
        console.log('[rc-legacy-add-guard] an add is already in flight; click ignored');
      } catch (error) {
        // Fail open.
      }
    },
    true
  );

  // A back/forward cache restore brings the page back as it was left; start unlocked.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      requests = [];
      lockedUntil = 0;
    }
  });
})();
